import Api from './DashboardConfig.api';
import { UserError } from 'utilities/ErrorHandlling/ErrorHandlling';
import { DashboardConfigConstants } from './DashboardConfig.constants';
import { isEmpty as _isEmpty } from 'lodash-es';

// --- Format :: new API('API URL', 'API SERVICE NAME - from api_service.jsx')
const dashboard = new Api('/', 'chart');
const batchAPI = new Api('/', 'batch');

export const getDashboardChartQueries = props => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: DashboardConfigConstants.GET_CHART_QUERY_CONFIGS_REQUEST });
      apiData = await dashboard.getDashboardChartQueries(props);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({ type: DashboardConfigConstants.GET_CHART_QUERY_CONFIGS_SUCCESS, payload: data });
      }
    } catch (error) {
      dispatch({ type: DashboardConfigConstants.GET_CHART_QUERY_CONFIGS_ERROR });
      throw new UserError(error);
    }
  };
};

export const getDashboardConfig = (props, dashboardType) => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: DashboardConfigConstants.GET_DASHBOARD_QUERIES_REQUEST });
      apiData = await dashboard.getDashboardConfig(props);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        if (!_isEmpty(dashboardType)) {
          dispatch({
            type: DashboardConfigConstants.GET_DASHBOARD_QUERIES_SUCCESS,
            payload: { [dashboardType]: data }
          });
        }
      }
    } catch (error) {
      dispatch({ type: DashboardConfigConstants.GET_DASHBOARD_QUERIES_ERROR });
      throw new UserError(error);
    }
  };
};

export const getHistoricalStatus = nickNameIDList => {
  let apiData = {};
  return async dispatch => {
    try {
      dispatch({ type: DashboardConfigConstants.GET_HISTORICAL_STATUS_REQUEST });
      apiData = await batchAPI.getHistoricalStatusConfig(nickNameIDList);
      if (apiData && apiData.hasError) {
        throw apiData;
      } else {
        const { data } = apiData;
        dispatch({ type: DashboardConfigConstants.GET_HISTORICAL_STATUS_SUCCESS, payload: data });
      }
    } catch (error) {
      dispatch({ type: DashboardConfigConstants.GET_HISTORICAL_STATUS_ERROR });
      throw new UserError(error);
    }
  };
};

// --- Logout user
// export const _logoutUser = () => {
//   const cookies = ['refreshToken', 'accessToken', 'locale'];
//   _forEach(cookies, cookieName => {
//     document.cookie = `${cookieName}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=${
//       process.env.NODE_ENV === 'development' ? 'localhost' : process.env.REACT_APP_COOKIE_PATH
//     };path=/`;
//   });
//   localStorage.removeItem('user_metadata');
//   localStorage.clear();
//   sessionStorage.clear();
//   window.location.href = '/login';
//   // ! Removed this code as need to refactor
//   setTimeout(() => {
//     const queryParams = new URLSearchParams(window.location.search);
//     const currentURL = window.location.href;
//     if (!currentURL.includes('tc_redirect_url') && !currentURL.includes('login') && !currentURL.includes('logout')) {
//       queryParams.set('tc_redirect_url', window.location.pathname);
//     }
//     window.location.replace(`${routesMapping?.signOut}?${queryParams.toString()}`);
//   }, 500);
// };
